"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ethjs_1 = __importDefault(require("ethjs"));

var contracts_1 = require("@archanova/contracts");

var EthError_1 = require("./EthError");

var Eth = /*#__PURE__*/function (_ethjs_1$default) {
  _inherits(Eth, _ethjs_1$default);

  var _super = _createSuper(Eth);

  function Eth(options, api, state) {
    var _this;

    _classCallCheck(this, Eth);

    _this = _super.call(this, api.toEthProvider(EthError_1.EthError));
    _this.options = options;
    state.eth$.next(_this.buildState());
    return _this;
  }

  _createClass(Eth, [{
    key: "getNetworkId",
    value: function getNetworkId() {
      var networkId = this.options.networkId;
      return networkId;
    }
  }, {
    key: "getContractAddress",
    value: function getContractAddress(contractName) {
      var result = null;
      var _this$options = this.options,
          networkId = _this$options.networkId,
          contractAddresses = _this$options.contractAddresses;

      if (contractAddresses && contractAddresses[contractName]) {
        result = contractAddresses[contractName];
      }

      if (!result) {
        result = contracts_1.getContractAddress(contractName, networkId);
      }

      return result;
    }
  }, {
    key: "buildState",
    value: function buildState() {
      var networkId = this.options.networkId;
      var networkName = 'Unknown';

      switch (networkId) {
        case '1':
          networkName = 'Main';
          break;

        case '3':
          networkName = 'Ropsten';
          break;

        case '4':
          networkName = 'Rinkeby';
          break;

        case '42':
          networkName = 'Kovan';
          break;

        case '77':
          networkName = 'Sokol';
          break;

        case '100':
          networkName = 'xDai';
          break;

        default:
          networkName = 'Local';
      }

      return {
        networkId: networkId,
        networkName: networkName
      };
    }
  }]);

  return Eth;
}(ethjs_1.default);

exports.Eth = Eth;